export default {
    async setCurrentLocale({commit}, locale) {
        commit('setLocale', locale);
    },
}